export enum CharterInvoicePaymentStatusEnum {
  Created = 1,
  AwaitingPayment = 2, // Unpaid
  PartiallyPaid = 3, // Partially Paid
  Fulfilled = 4, // Paid
  Cancelled = 5,
  Deactivated = 6,
}
